import { Input } from "@/components/ui/input";
import { FileUp } from "lucide-react";

interface FileUploaderProps {
  onFileSelect: (file: File) => void;
}

export function FileUploader({ onFileSelect }: FileUploaderProps) {
  return (
    <div className="relative mx-auto flex max-w-[600px] flex-col items-center justify-center gap-4 rounded-xl border-2 border-dashed border-border bg-muted/40 p-10 transition-colors hover:bg-muted/60">
      <div className="rounded-full bg-card p-4">
        <FileUp className="h-8 w-8 text-primary" />
      </div>
      <div className="text-center">
        <p className="text-sm font-medium text-foreground">
          Click to upload or drag and drop
        </p>
        <p className="mt-1 text-xs text-muted-foreground">CSV files only (UTF-8)</p>
      </div>
      <Input
        type="file"
        accept=".csv"
        className="hidden"
        id="csv-upload"
        onChange={(e) => e.target.files?.[0] && onFileSelect(e.target.files[0])}
      />
      <label htmlFor="csv-upload" className="absolute inset-0 cursor-pointer" />
    </div>
  );
}
